
import Image from '@/components/Image.vue'
import OverviewBox from '@/components/overview/OverviewBox.vue'
import { IUnitsBoxData } from '@/__types__/overview'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'BuildingsBox',
  props: {
    data: {
      type: Object as PropType<IUnitsBoxData>,
      required: true,
    },
  },
  components: { OverviewBox, Image },
})
